export default __webpack_public_path__ + "static/media/grant-explorer.93e8d33d.svg";